import { useEffect } from "react";
import "../styles/signup.css";

function SignUp() {
	//opens signup form when button is clicked
	const openSignupFrom = () => {
		window.open("https://forms.gle/ivQ3YKqAYfdJ2iPf8", "_blank");
	};

	const openDiscordForm = () => {
		window.open("https://discord.gg/kmTyqfQGHZ", "_blank");
	};

	//scrolls to certain section of page when button is clicked
	const scroll = () => {
		document.querySelector(".info-scroll-box").scrollIntoView({ behavior: "smooth" });
	};

	//for scroll animation effects
	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const element = entry.target;
				if (entry.isIntersecting) {
					element.classList.add("show");
				} else {
					element.classList.remove("show");
				}
			});
		});
		const hiddenElements = document.querySelectorAll(".hidden");
		//add each element to be observed
		hiddenElements.forEach((element) => {
			observer.observe(element);
		});
	});

	return (
		<div className="signup-scroll-box">
			<div className="signup-main">
				<div className="signup-top-bar hidden">
					<div onClick={scroll} className="bar-btn">
						Event Info
					</div>
					<div onClick={openDiscordForm} className="bar-btn">
						Discord
					</div>
					<div onClick={openDiscordForm} className="bar-btn">
						Contact
					</div>
				</div>
				<div>
					<div className="hack-title hidden">Encode Justice Washington Hackathon</div>
				</div>
				<div className="hack-date hidden">April 1 - 15, 2023</div>
				<div onClick={openSignupFrom} className="signup-btn hidden">
					Sign Up!
				</div>
				<div className="signup-until hidden">
					Registration open till April 14th
					<br />
					&nbsp;&nbsp;&nbsp;&nbsp; Join <a href="https://discord.gg/kmTyqfQGHZ">Discord</a> for updates
				</div>
			</div>
		</div>
	);
}

export default SignUp;
